import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { WithChildren } from 'ts-types';

export const SkeletonWrapper: FC<{ isShow: boolean; height: number } & WithChildren> = ({
  isShow,
  height,
  children
}) => {
  if (isShow) return <Skeleton height={height} />;
  return <>{children}</>;
};
